// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
export { default } from '/Users/jilin/projects/antd/rc-dialog/node_modules/_dumi@2.4.17@dumi/theme-default/slots/ContentTabs/index.js';
